import { FC } from "react";
import Header from "../../../components/layout/Header";
import PublisherSearchForm from "../../../components/system/publisher/PublisherSearchForm";
import PublisherTable from "../../../components/system/publisher/PublisherTable";
import { useTranslation } from "react-i18next";

const SystemPublisher: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="content-wrapper">
      <Header
        iconFile="icon-system-big.svg"
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.publisher.13')}
      />
      <div className="main max-w1200p">
        <PublisherSearchForm />
        <PublisherTable />
      </div>
    </div>
  );
};

export default SystemPublisher;